<div id="promo-wrapper">
  <section id="promo" class="mt-4 mb-4">
    <div class="container dark">

      <header>
        <h2 i18n>Häufig gestellte Fragen (FAQ)</h2>
      </header>

      <p i18n>Hier finden Sie Antworten auf häufig gestellte Fragen zu unseren Dienstleistungen und unserem Unternehmen.
      </p>

    </div>
  </section>
</div>
<div class="wrapper pb-3">
  <section class="container">
    <div class="row features justify-content-center ">

      <section id="faq" class="faq">

        <div class="faq-item">
          <h3 i18n>Was macht AlbCode genau?</h3>
          <p i18n>AlbCode entwickelt individuelle Softwarelösungen für Unternehmen – von Webportalen über mobile Apps bis hin zu komplexen Backend-Systemen und Anbindung verschiedener
            Schnittstellen. Wir unterstützen Sie bei der Digitalisierung Ihrer Geschäftsprozesse, sowie Ihrer Online-Präsenz.</p>
        </div>

        <div class="faq-item">
          <h3 i18n>Welche Technologien verwendet AlbCode?</h3>
          <p i18n>Wir arbeiten mit modernen Technologien wie Java, Spring Boot, Angular, TypeScript, PostgreSQL und Docker. So entstehen stabile, skalierbare und zukunftssichere
            Anwendungen.</p>
        </div>

        <div class="faq-item">
          <h3 i18n>Für welche Branchen entwickelt AlbCode Software?</h3>
          <p i18n>Wir entwickeln branchenunabhängig – ob Handwerk, Industrie, Dienstleistung oder Verwaltung. Unser Fokus liegt auf passgenauer Software, nicht auf
            Standardlösungen.</p>
        </div>

        <div class="faq-item">
          <h3 i18n>Wie läuft ein Projekt mit AlbCode ab?</h3>
          <p i18n>Wir starten mit einer Analyse Ihres Bedarfs, erstellen ein technisches Konzept und setzen die Software agil in enger Abstimmung mit Ihnen um – inklusive
            Hosting und Wartung, falls gewünscht.</p>
        </div>

        <div class="faq-item">
          <h3 i18n>Wo ist AlbCode ansässig und für wen arbeitet AlbCode?</h3>
          <p i18n>AlbCode hat seine Wurzeln in Hechingen auf der Schwäbischen Alb. Regional sind wir gerne persönlich für unsere Kunden da – deutschlandweit und international arbeiten
            wir flexibel und remote. Egal ob um die Ecke oder über Kontinente hinweg: Wir bringen Projekte zuverlässig zum Ziel.</p>
        </div>

        <div class="faq-item">
          <h3 i18n>Was kostet mich ein Projekt mit AlbCode?</h3>

          <p i18n>Die Kosten für ein Projekt mit AlbCode hängen von verschiedenen Faktoren ab – etwa vom Umfang, der Komplexität und den gewünschten Funktionen. Aber keine Sorge: Sie
            behalten jederzeit den Überblick. Wir legen großen Wert auf Kostentransparenz und stimmen jeden Schritt mit Ihnen ab.</p>

          <h4 class="pb-3" i18n>Warum individuelle Software günstiger ist, als viele denken</h4>

          <p i18n>Viele kleine und mittlere Unternehmen (KMU) zögern bei der Entscheidung für individuelle Softwarelösungen. Der Grund: Die Annahme, dass maßgeschneiderte Software
            teuer, kompliziert und nur für Großunternehmen geeignet ist.</p>
          <p i18n>Doch diese Vorurteile halten einer genaueren Betrachtung oft nicht stand. Tatsächlich kann eine individuell entwickelte Software langfristig kosteneffizienter und
            passgenauer sein als Standardlösungen oder cloud-basierte Software-as-a-Service-Produkte (SaaS).</p>

          <h4 class="pb-3" i18n>„Individuelle Software ist zu teuer“ – ein Vorurteil</h4>
          <p i18n>Es stimmt, dass die initialen Kosten für die Entwicklung individueller Software höher sein können als die Anschaffungskosten von Standardsoftware. Allerdings sind
            diese Anfangsinvestitionen oft gut angelegt:</p>
          <ul>
            <li i18n><strong>Keine laufenden Lizenzgebühren:</strong> Im Gegensatz zu SaaS-Modellen entfallen regelmäßige Lizenzkosten.</li>
            <li i18n><strong>Maßgeschneiderte Funktionen:</strong> Sie zahlen nur für das, was Sie wirklich brauchen.</li>
            <li i18n><strong>Langlebigkeit:</strong> Gute Software hält viele Jahre ohne teure Upgrades.</li>
          </ul>
          <p i18n>Ein Vergleich der Gesamtkosten über 3 bis 5 Jahre zeigt oft: individuell ist günstiger.</p>

          <h4 class="pb-3" i18n>Standardsoftware: Versteckte Kosten und Einschränkungen</h4>
          <ul>
            <li i18n><strong>Anpassungsbedarf:</strong> Oft müssen Standardtools teuer nachgerüstet werden.</li>
            <li i18n><strong>Ineffiziente Workarounds:</strong> Prozesse werden angepasst, nicht die Software – das kostet Zeit und Geld.</li>
            <li i18n><strong>Vendor-Lock-in:</strong> SaaS-Produkte binden Sie an einen Anbieter.</li>
          </ul>
          <p i18n>Diese Faktoren erhöhen langfristig die Gesamtkosten deutlich.</p>

          <h4 class="pb-3" i18n>Die Vorteile individueller Software für KMU</h4>
          <ul>
            <li i18n><strong>Passgenau:</strong> Exakt auf Ihre Prozesse zugeschnitten</li>
            <li i18n><strong>Skalierbar:</strong> Wächst mit Ihrem Unternehmen</li>
            <li i18n><strong>Wettbewerbsvorteil:</strong> Kein Einheitsbrei – sondern Software, die Sie einzigartig macht</li>
            <li i18n><strong>Unabhängigkeit:</strong> Keine Abhängigkeit von SaaS-Anbietern</li>
          </ul>

          <h4 class="pb-3" i18n>Fazit: Individuelle Software lohnt sich</h4>
          <p i18n>Die Entscheidung für individuelle Software sollte nicht allein auf den initialen Kosten basieren. Vielmehr zählt der langfristige Nutzen. Für viele KMU ist eine
            maßgeschneiderte Lösung der bessere Weg – kosteneffizient, zukunftssicher und flexibel.</p>
          <p i18n>Sie haben Interesse? <a [routerLink]="['/contact']">Kontaktieren Sie uns</a> – wir beraten Sie gerne!</p>

        </div>

      </section>

    </div>
  </section>
</div>